var ShapeStatusEnum;
(function (ShapeStatusEnum) {
    ShapeStatusEnum[ShapeStatusEnum["PROCESSING"] = 1] = "PROCESSING";
    ShapeStatusEnum[ShapeStatusEnum["PROCESSD"] = 2] = "PROCESSD";
    ShapeStatusEnum[ShapeStatusEnum["FAILED_PROCESSING"] = 3] = "FAILED_PROCESSING";
})(ShapeStatusEnum || (ShapeStatusEnum = {}));
export default ShapeStatusEnum;
